import { render, staticRenderFns } from "./DataCollected.vue?vue&type=template&id=2149a1f4&"
import script from "./DataCollected.vue?vue&type=script&lang=js&"
export * from "./DataCollected.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports